import React from 'react';
import { Container } from 'telia-front-react';
import config from '../Config';

interface WrapWithContainerInFullPageProps {
  children: React.JSX.Element | (React.JSX.Element | boolean)[];
}

const WrapWithContainerInFullPage = (props: WrapWithContainerInFullPageProps): React.JSX.Element | (React.JSX.Element | boolean)[] => {
  const { children } = props;
  const isModule = config.isModule;

  if (isModule) {
    return children;
  }
  return <Container>{children}</Container>;
};

export default WrapWithContainerInFullPage;
